import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ICustomGetCalificacionesReq } from 'src/app/interfaces/calificaciones';

export interface IEvaluacionFechaDTO {
  fechaEvaluacion?: string | null;
  tipoCalificacion: string;
  nroNota: number;
  nombre: string;
  glosa: string;
  sigla: string;
  porcentaje: number;
  seccionEvaluacionId: number
  editable: boolean
  ponderacionBaseId: number
}

export interface IGuardarFechasEvaluacionesReqNew {
  idSeccion: number;
  seccionEvaluacionId: number;
  ponderacionBaseId: number
  jsonDatos: {
    tipoNota: string;
    nroNota: number;
    fechaEvaluacion: string | null;
  }[];
}

@Injectable({
  providedIn: 'root'
})
export class EvaluacionesFechasService {
  constructor(private http: HttpClient) {}

  getHeaders(): HttpHeaders {
    return new HttpHeaders();
  }

  /**
   * Obtiene la lista de evaluaciones con sus fechas (si existen) para la sección.
   * */
  getEvaluacionesFechas(customReq: ICustomGetCalificacionesReq): Observable<IEvaluacionFechaDTO[]> {
    const url = `${environment.endpointDocente}/v1/registro-calificacion/obtenerListaFechas`
      + `?id-seccion=${customReq.seccionId}`
      + `&ponderacion-base-id=${customReq.ponderacionId}`
    return this.http.get<IEvaluacionFechaDTO[]>(url, { headers: this.getHeaders() });
  }

  /**
   * Guarda/actualiza fechas seleccionadas para evaluaciones de la sección.
   */
  postGuardarEvaluacionesFechas(body: IGuardarFechasEvaluacionesReqNew): Observable<any> {
    const url = `${environment.endpointDocente}/v1/registro-calificacion/guardarListaFechas`;
    return this.http.post<any>(url, body, { headers: this.getHeaders() });
  }
}
